<div class="exchange-server" *ngIf="isShow">
    <div>
        <label>{{'exchange.integration_type' | stringLiterals}}</label>
    </div>
    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [(ngModel)]="integrationType" #dropDownEl
        [data]="suggestionItems" class="exchange-type" (focus)="dropDownEl.toggle(true)"
        (mousedown)="$event.preventDefault()" [disabled]="true">
    </kendo-dropdownlist>
    <div class="integeration-setup control-border">
        <div class="integeration-setup-title">
            <label class="exchange-setup">{{'crm.integration_setup' | stringLiterals}} </label>
            <label class="exchange-fetchapp-tip">{{'exchange.if_fetch_app_is_running' | stringLiterals}}</label>
        </div>
        <div>
            <label>Client ID<span class="required-field">&nbsp;*</span></label>
        </div>
        <input tid="Client ID" class="tam-input exchange-input" [(ngModel)]="clientId" [disabled]="isEnable" />
        <label *ngIf="!(clientId.trim())" class="exchange-error"> {{'general.required_error_message' |
            stringLiterals}}</label>
        <div>
            <label>Client Secret<span class="required-field">&nbsp;*</span></label>
        </div>
        <input tid="Client Secret" class="tam-input exchange-input" [(ngModel)]="clientSecret" [disabled]="isEnable"
            [type]="!isEnable?'text':'password'" />
        <label *ngIf="!(clientSecret.trim())" class="exchange-error">{{'general.required_error_message' |
            stringLiterals}}</label>
        <div>
            <label>{{'exchange.tenant' | stringLiterals}}<span class="required-field">&nbsp;*</span></label>
        </div>
        <input tid="Tenant" class="tam-input exchange-input" [(ngModel)]="tenant" [disabled]="isEnable" />
        <label *ngIf="!(tenant.trim())" class="exchange-error">{{'general.required_error_message' |
            stringLiterals}}</label>
        <div>
            <div class="switch-label">
                <label>{{'exchange.enable_disable_connection' | stringLiterals}}<span *ngIf="isEnable">
                        {{connectStatus}}</span></label>
            </div>

            <div>
                <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="isEnable" (valueChange)="changeEnable($event)"
                    [disabled]="!(clientId.trim())||!(clientSecret.trim())||!(tenant.trim())"></kendo-switch>
            </div>
            <label class="exchange-error" *ngIf="error">{{error}}</label>
        </div>
    </div>

    <div class="sync-ruler control-border" *ngIf="isEnable">
        <span class="sync-auto-title">{{'exchange.auto_synchronization_settings' | stringLiterals}}</span>
        <label class="sync-auto-label" (click)="settingAutoSync()">{{'exchange.view_sync_settings' |
            stringLiterals}}</label>
        <span class="sync-auto-button-title">{{'exchange.allow_individual_user_to_set_auto_sync' |
            stringLiterals}}</span>
        <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="isEnableSyncAuto"
            (valueChange)="changeAutoSyncEnable($event)">
        </kendo-switch>
    </div>
    <div class="sync-ruler control-border" *ngIf="isEnable">
        <div class="rules">
            <label>{{'exchange.field_mapping' | stringLiterals}}</label>
        </div>
        <label class="view-mapping" (click)="viewMapping()">{{'exchange.view_field_mapping' | stringLiterals}}<span
                *ngIf="lastUpdate" style="color:gray">&nbsp;(Updated
                on
                {{lastUpdate}})</span></label>
    </div>

    <div class="category-setting control-border" *ngIf="isEnable">
        <div class="title">
            <label class="content">{{'exchange.category_settings_for_deposited_event_and_email' |
                stringLiterals}}</label>
            <label class="tip">{{'exchange.this_feature_requires_application' | stringLiterals}}</label>
        </div>
        <div>
            <div class="switch-label">
                <label class="category-content">{{'exchange.enable_email_event_indication' | stringLiterals}}</label>
            </div>
            <div>
                <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="isEnableCategoryNameColor"
                    (valueChange)="changeEmailEventIndicationEnable()" [disabled]="!(categoryName.trim())">
                </kendo-switch>
            </div>
        </div>
        <div>
            <div class="switch-label">
                <label
                    class="category-content">{{'exchange.remove_category_for_the_email_in_outlook_when_the_associated_note_is_deleted'
                    |
                    stringLiterals}}</label>
            </div>
            <div>
                <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="isEnableRemoveCategory"
                    [disabled]="isEnableCategoryNameColor"></kendo-switch>
            </div>
        </div>
        <div class="category-name-color">
            <div class="category-content">
                <label>{{'exchange.category_name_and_color' | stringLiterals}}<span
                        class="required-field">&nbsp;*</span></label>
            </div>
            <div class="content">
                <div #anchor class="format-detail">
                    <input class="tam-input exchange-input" [(ngModel)]="categoryName"
                        [disabled]="isEnableCategoryNameColor" />
                    <div class="button-area">
                        <div class="color-button-area">
                            <div class="color-button" (click)="addColor($event)">
                                <smart-icon name="background-color"></smart-icon>
                            </div>
                            <div class="color-bar" [style.background-color]="selectedColor"
                                [style.border-color]="selectedColor"></div>
                        </div>
                    </div>
                </div>
                <label *ngIf="!(categoryName.trim())" class="exchange-error"> {{'general.required_error_message' |
                    stringLiterals}}</label>
                <kendo-popup [anchor]="anchor" *ngIf="showPopup">
                    <table>
                        <tbody>
                            <tr class="row">
                                <td class="cell" *ngFor="let color of colors|slice:0:13;trackBy:trackByFn">
                                    <div class="one-color" [style.background-color]="color"
                                        (click)="chooseColor(color)"></div>
                                </td>
                            </tr>
                            <tr class="row">
                                <td class="cell" *ngFor="let color of colors|slice:13:26;trackBy:trackByFn">
                                    <div class="one-color" [style.background-color]="color"
                                        (click)="chooseColor(color)"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </kendo-popup>
            </div>
        </div>
        <label class="exchange-error" *ngIf="categoryError">{{categoryError}}</label>
    </div>
</div>